const comparator = (includesString, searchString) =>
  includesString?.toLowerCase()?.includes?.(searchString?.toLowerCase()) ||
  false;

export default comparator;
